export const DEFAULT_ANYWAY_PARTNER_BG_COLOR = '#c4ff57';
